module.exports = __webpack_public_path__ + "img/lishirenwu@3x.37a7f733.png";